import React from 'react';
import ReactDOM from 'react-dom/client';
import { RehubSupabaseTracking } from '@rehub/tracking/react';
import App from './App';
import { supabase } from './services/supabase';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
    <RehubSupabaseTracking app="planos" mode="events-only" supabase={supabase} />
  </React.StrictMode>
);
